import * as Service from './service';

export const TOGGLE_CART = 'CART/TOGGLE';
export const ADD_TO_CART_PENDING = 'CART/ADD/PENDING';
export const CART_UPDATE_QUANTITY = 'CART/UPDATE_QUANTITY';
export const UPDATE_ORDER_PENDING = 'CART/UPDATE_ORDER/PENDING';
export const UPDATE_ORDER_SUCCESS = 'CART/UPDATE_ORDER/SUCCESS';

export const PRODUCT_SIZEGUIDE = 'PRODUCT/SIZE_GUIDE';

export function toggleCart() {
  return { type: TOGGLE_CART };
}

export function updateOrder(order) {
  return { type: UPDATE_ORDER_SUCCESS, payload: order };
}

export function updateQuantity(variantId, quantity = 1) {
  return (dispatch) => {
    dispatch({type: UPDATE_ORDER_PENDING});

    Service.updateQuantity(variantId, quantity)
      .then(order => dispatch(updateOrder(order)));
  };
}

export function addToCart(variantId, quantity = 1) {
  return (dispatch) => {
    dispatch({ type: ADD_TO_CART_PENDING });

    return Service.addToCart(variantId, quantity)
    .then(order => dispatch(updateOrder(order)));
  }
}


// WEBPACK FOOTER //
// ./assets/scripts/redux/actions.js